<template>
	<svg :width="props.width" :height="props.height" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clip-path="url(#clip0_19213_14000)">
			<path
				d="M11.8893 5.68164C8.56858 5.68164 5.87891 8.42377 5.87891 11.8093C5.87891 14.4163 7.48126 16.6382 9.73322 17.5223C9.78758 17.5436 9.84565 17.554 9.90405 17.554C10.1727 17.554 10.3905 17.3362 10.3905 17.0675V14.8658C10.3905 14.6583 10.5587 14.4902 10.7661 14.4902C10.9736 14.4902 11.1418 14.6583 11.1418 14.8658V16.8027C11.1418 17.2176 11.4782 17.554 11.8931 17.554C12.308 17.554 12.6444 17.2176 12.6444 16.8027V14.8658C12.6444 14.6583 12.8126 14.4902 13.0201 14.4902C13.2275 14.4902 13.3957 14.6583 13.3957 14.8658V17.0707C13.3957 17.3376 13.6121 17.554 13.879 17.554C13.937 17.554 13.9947 17.5437 14.0487 17.5225C16.3009 16.6386 17.9035 14.4165 17.9035 11.8093C17.9035 8.42377 15.2139 5.68164 11.8931 5.68164H11.8893Z"
				:fill="props.iconColor"
			/>
			<path
				d="M14.0058 20.0949C14.0586 19.9754 13.963 19.8516 13.8323 19.8516H9.9453C9.81468 19.8516 9.71903 19.9754 9.77182 20.0949C10.0071 20.6274 10.528 21.0005 11.1375 21.0005H12.6401C13.2497 21.0005 13.7706 20.6274 14.0058 20.0949Z"
				:fill="props.iconColor"
			/>
			<path
				d="M14.1445 18.4987C14.1445 18.3991 14.0638 18.3184 13.9642 18.3184H9.81328C9.71577 18.3184 9.63672 18.3974 9.63672 18.4949V18.7013C9.63672 18.9129 9.80818 19.0843 10.0197 19.0843H13.7616C13.9731 19.0843 14.1445 18.9129 14.1445 18.7013V18.4987Z"
				:fill="props.iconColor"
			/>
			<path
				d="M12.2669 4.15626V3.37565C12.2669 3.16819 12.0987 3 11.8913 3C11.6838 3 11.5156 3.16819 11.5156 3.37565V4.15626C11.5156 4.36373 11.6838 4.53191 11.8913 4.53191C12.0987 4.53191 12.2669 4.36373 12.2669 4.15626Z"
				:fill="props.iconColor"
			/>
			<path
				d="M20.147 11.4258H19.4103C19.1988 11.4258 19.0273 11.5972 19.0273 11.8088C19.0273 12.0203 19.1988 12.1917 19.4103 12.1917H20.147C20.3585 12.1917 20.53 12.0203 20.53 11.8088C20.53 11.5972 20.3585 11.4258 20.147 11.4258Z"
				:fill="props.iconColor"
			/>
			<path
				d="M4.36963 11.4258H3.63298C3.42147 11.4258 3.25 11.5972 3.25 11.8088C3.25 12.0203 3.42147 12.1917 3.63298 12.1917H4.36963C4.58114 12.1917 4.75261 12.0203 4.75261 11.8088C4.75261 11.5972 4.58114 11.4258 4.36963 11.4258Z"
				:fill="props.iconColor"
			/>
			<path
				d="M6.83985 6.12042L6.3086 5.5788C6.1619 5.42924 5.92405 5.42924 5.77734 5.5788C5.63064 5.72837 5.63064 5.97085 5.77734 6.12042L6.3086 6.66203C6.4553 6.81159 6.69315 6.81159 6.83985 6.66203C6.98655 6.51247 6.98655 6.26998 6.83985 6.12042Z"
				:fill="props.iconColor"
			/>
			<path
				d="M18 17.4954L17.4688 16.9538C17.3221 16.8042 17.0842 16.8042 16.9375 16.9538C16.7908 17.1034 16.7908 17.3459 16.9375 17.4954L17.4688 18.037C17.6155 18.1866 17.8533 18.1866 18 18.037C18.1467 17.8875 18.1467 17.645 18 17.4954Z"
				:fill="props.iconColor"
			/>
			<path
				d="M17.4688 5.58016L16.9375 6.12177C16.7908 6.27133 16.7908 6.51382 16.9375 6.66338C17.0842 6.81295 17.3221 6.81295 17.4688 6.66339L18 6.12177C18.1467 5.97221 18.1467 5.72972 18 5.58016C17.8533 5.43059 17.6155 5.43059 17.4688 5.58016Z"
				:fill="props.iconColor"
			/>
			<path
				d="M6.3086 16.9552L5.77735 17.4968C5.63064 17.6463 5.63064 17.8888 5.77734 18.0384C5.92405 18.1879 6.1619 18.1879 6.3086 18.0384L6.83985 17.4968C6.98655 17.3472 6.98655 17.1047 6.83985 16.9552C6.69315 16.8056 6.4553 16.8056 6.3086 16.9552Z"
				:fill="props.iconColor"
			/>
		</g>
		<defs>
			<clipPath id="clip0_19213_14000">
				<rect width="17.28" height="18" :fill="props.iconColor" transform="translate(3.25 3)" />
			</clipPath>
		</defs>
	</svg>
</template>
<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		width?: string | number;
		height?: string | number;
		iconColor?: string;
	}>(),
	{
		width: 24,
		height: 24,
		iconColor: '#ffffff',
	}
);
</script>

<style lang="scss" scoped></style>
